module.exports = __webpack_public_path__ + "img/unpublished.4e1984b1.svg";